import type { AnyAction, AsyncThunk } from '@reduxjs/toolkit';
import { isAnyOf } from '@reduxjs/toolkit';

export type GenericAsyncThunk = AsyncThunk<unknown, unknown, any>;
export type PendingAction = ReturnType<GenericAsyncThunk['pending']>;
export type RejectedAction = ReturnType<GenericAsyncThunk['rejected']>;
export type FulfilledAction = ReturnType<GenericAsyncThunk['fulfilled']>;

export const isPendingAction = (action: AnyAction): action is PendingAction => action.type.endsWith('/pending');
export const isRejectedAction = (action: AnyAction): action is RejectedAction => action.type.endsWith('/rejected');
export const isFulfillAction = (action: AnyAction): action is FulfilledAction => action.type.endsWith('/fulfilled');

export const addStateFetch = (builder, key = 'fetch'): typeof builder =>
    builder
        .addMatcher(isPendingAction, (s) => {
            s.fetch = true;
        })
        .addMatcher(isAnyOf(isFulfillAction, isRejectedAction), (s) => {
            s[key] = false;
        });
